var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.281px",
    height: "396.85px",
    viewBox: "0 0 595.281 396.85",
    enableBackground: "new 0 0 595.281 396.85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu",
    fill: "#333333",
    d: "M434.058,285.236v24.804c0,6.849-5.553,12.401-12.402,12.401H173.625 c-6.849,0-12.401-5.553-12.401-12.401v-24.804c0-6.849,5.552-12.401,12.401-12.401h248.031 C428.505,272.834,434.058,278.387,434.058,285.236z M421.656,74.409H173.625c-6.849,0-12.401,5.553-12.401,12.401v24.804 c0,6.849,5.552,12.401,12.401,12.401h248.031c6.85,0,12.402-5.553,12.402-12.401V86.811 C434.058,79.962,428.505,74.409,421.656,74.409z M421.656,173.622H173.625c-6.849,0-12.401,5.552-12.401,12.401v24.803 c0,6.85,5.552,12.401,12.401,12.401h248.031c6.85,0,12.402-5.552,12.402-12.401v-24.803 C434.058,179.174,428.505,173.622,421.656,173.622z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.1d5d73b5213ffe951e1c33b3ac14a4c1.svg";
export { ForwardRef as ReactComponent };